/**
 * 翻译存储服务钩子
 * 提供便捷访问翻译存储服务的方法
 *
 * 核心功能：
 * 1. 简化使用翻译存储服务的方式
 * 2. 自动处理错误情况
 * 3. 确保依赖注入正确配置
 */
import { useCallback } from 'react';
import { getTranslationStorageService } from '../contexts/StorageContext.js';
import { LoggerService } from '../../logging/services/logger.service.js';
/**
 * 使用翻译存储服务钩子
 * 便于在React组件中使用翻译存储服务
 *
 * @returns 翻译存储服务实例
 * @throws 如果服务未注册则抛出错误
 *
 * @example
 * ```tsx
 * const translationStorage = useTranslationStorage();
 *
 * // 保存翻译
 * const saveTranslation = async () => {
 *   const translationId = await translationStorage.saveTranslation({
 *     textId: 1,
 *     paragraphId: 'p1',
 *     originalText: 'Hello',
 *     translatedText: '你好',
 *     sourceLanguage: 'en',
 *     targetLanguage: 'zh',
 *     selectionStart: 0,
 *     selectionEnd: 5
 *   });
 * };
 * ```
 */
export function useTranslationStorage() {
    const logger = LoggerService.getInstance();
    // 使用useCallback来缓存服务实例获取方法
    return useCallback(() => {
        try {
            return getTranslationStorageService();
        }
        catch (error) {
            logger.error('[useTranslationStorage] Failed to get translation storage service', { error });
            throw error;
        }
    }, [logger])();
}
/**
 * 默认导出钩子函数
 */
export default useTranslationStorage;
//# sourceMappingURL=useTranslationStorage.js.map